
import wx from 'weixin-js-sdk'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'


export default {
name: 'workOrderInfo',
directives: {
TransferDom
},
components: {
wx,XTextarea,Group,Popup,PopupHeader,XButton,Radio,
},
data () {
return {
title:'工单详情',
id:0,
info:{
community:{},
},
reply:[],
content:'',
format:0,
grade:0,
pickerStatus:false,
quickReplys:[],
quickReplyId:0,
services:[],
serviceId:0,
pickerStatus1:false,
status:true,

}
},
created(){
this.id = Number(this.$route.params.id);
this.config();
if(!this.$func.getLocal('token')){
this.getCode();
}else{
this.workOrderInfo();
this.grade = parseInt(this.$func.getLocal('grade'));
}
},
mounted(){
if(this.$func.getLocal('token')){
this.getService();
}
},
methods:{
getCode(){
var local = window.location.href
this.code = this.getUrlCode().code
if(this.$func.getLocal('channel') > 0){
var appid = 'wx28eee363742d8f7e'
}else{
var appid = 'wx319f232455d7da71'
}
if (this.code == null || this.code === '') {
window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
} else {
this.login();
}
},
getUrlCode() {
var url = window.location.href
var theRequest = new Object()
if (url.indexOf("?") != -1) {
var urls = url.split("?")
var strs = urls[1].split("&")
for(var i = 0; i < strs.length; i++) {
theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
}
}
var code = theRequest.code;
if(code == 'undefined' || code == null || code === ''){
this.$func.setLocal('channel',parseInt(theRequest.channel));
}
return theRequest
},
login(){
this.$api.login({code:this.code,channel:this.$func.getLocal('channel')}).then((res)=>{
if(res){
if(res.data.token){
this.$func.setLocal('token',res.data.token);
this.$func.setLocal('grade',res.data.grade);
this.grade = parseInt(this.$func.getLocal('grade'))
this.workOrderInfo();
this.getService();
}
}
})
},
copy(val){
this.$func.copy(val,event);
},
workOrderInfo(){
this.$api.workOrderInfo({id:this.id}).then((res)=>{
if(res){
console.log(res);
this.info = res.data;

this.quickReply();

this.workOrderReply();
}
})
},
workOrderReply(){
this.$api.workOrderReply({id:this.id}).then((res)=>{
if(res){
this.reply = res.data;
}
})
},
submitReply(content,format){
if(!this.status){
return false;
}
this.status = false;
let content1 = content ? content : this.content;
if(!content1){
this.$func.showToast('请输入回复内容');
return false;
}
this.$api.submitWorkReply({id:this.id,cid:this.info.cid,content:content1,format:format ? format : this.format}).then((res)=>{
if(res){
this.content = '';
this.workOrderReply();
this.status = true;
this.$func.endLoading();
}
})
},
quickReply(){
this.$api.quickReply({}).then((res)=>{
if(res){
this.quickReplys = res.data;
}
})
},
onQuickReplyChange (value) {
this.quickReplyId = value;
},
changeStatus(value){
switch(parseInt(value)){
case 3:
if(this.info.status == 2){
if(!this.quickReplyId){
this.$func.showToast('请选择快捷回复');
return false;
}
this.quickReplys.forEach((item,index) => {
if(item.key == this.quickReplyId){
this.content = item.value;
}
});
}else{
this.content = '没解决';
}
break
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.changeWorkStatus({id:this.id,status:value,content:this.content}).then((res)=>{
if(res){
this.pickerStatus = false;
this.content = '';
this.workOrderInfo();
}
})
})
},
showPic(pics,index) {
wx.previewImage({
current: pics[index], // 当前显示图片的http链接
urls: pics 
});
},
getService(){
this.$api.getService({}).then((res)=>{
if(res){
this.services = res.data;
}
})
},
onSercice (value) {
this.serviceId = value;
},
confirmService () {
let that = this;
if(!this.serviceId){
this.$func.showToast('请选择客服');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.assignService({id:this.id,serviceId:this.serviceId}).then((res)=>{
if(res){
that.pickerStatus1 = false;
that.workOrderInfo();
}
})
})
},
workOrderSolution(){
this.$router.push({name:'workOrderSolution',params:{id:this.id}})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
]
});
}
})
},
uploadFile(){
let that = this;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
this.$func.startLoading();
let localId = localIds.pop();
let that = this;
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImg({serverId:res.serverId,path:'work'}).then((res)=>{
if(res){
that.submitReply(res.data.path,2);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
hide1(e){
console.log(this.option1);
}
}
}



// WEBPACK FOOTER //
// ./src/pages/workOrderInfo.vue